module.exports = __webpack_public_path__ + "static/media/Vegetable-Sandwich.b90e1acc.jpg";